var exports = {
  "kL": "ThreadWelcomeSection.module__container___LThUZ2",
  "Kk": "ThreadWelcomeSection.module__icon___LThUZ2",
  "e5": "ThreadWelcomeSection.module__iconGlyph___LThUZ2",
  "R_": "ThreadWelcomeSection.module__heading___LThUZ2",
  "h_": "ThreadWelcomeSection.module__description___LThUZ2",
};

module.exports = exports;
